import { Module } from 'vuex';
import { UserState } from '@/store/modules/user/user-state.model';
import { ApplicationLayout } from '@/store/modules/application';
import { IIdentity, ISignInCommand } from '@/connectors/identity/identity.model';
import { IdentitiesConnector } from '@/connectors/identity/identities.connector';
import axios from 'axios';
import router from '@/router';
import { JwtHelper } from '@/utils/jwt.helper';
const identityConnector = new IdentitiesConnector();

export const UserModule: Module<UserState, any> = {
  namespaced: true,
  mutations: {
    login(s: UserState, payload: IIdentity) {
      s.isLoggedIn = true;
      s.refreshToken = payload.refreshToken;
      s.accessToken = payload.accessToken;
    },
    logout(s: UserState) {
      s.isLoggedIn = false;
      s.refreshToken = '';
      s.accessToken = '';
    },
    setEmail(s: UserState, payload: string) {
      s.username = payload;
    }
  },
  state: {
    isLoggedIn: false,
    refreshToken: '',
    accessToken: '',
    username: ''
  },
  actions: {
    async login(ctx, payload: ISignInCommand | string): Promise<boolean> {
      try {
        let result;

        if (typeof payload === 'string') {
          result = await identityConnector.refreshToken(payload as string);
        } else {
          result = await identityConnector.signIn(payload as ISignInCommand);
        }

        if (result) {
          localStorage.setItem('identity', JSON.stringify(result));
          ctx.commit('login', result);

          axios.defaults.headers.common.Authorization = 'Bearer ' + result.accessToken;

          ctx.commit('application/changeLayout', ApplicationLayout.default, {
            root: true
          });

          await ctx.dispatch('initMetadata');
          await ctx.dispatch('application/fetchConfig', null, { root: true });
          // await ctx.dispatch('metadata/initAll', null, { root: true });

          return true;
        }

        await ctx.dispatch('logout');
        return false;
      } catch (e) {
        await ctx.dispatch('logout');
        throw e;
      }
    },
    async logout(ctx) {
      ctx.commit('application/changeLayout', ApplicationLayout.login, {
        root: true
      });
      ctx.commit('logout');
      localStorage.removeItem('identity');

      if (router.currentRoute.name !== 'login') {
        await router.push('/login');
      }
    },
    async initMetadata(ctx) {
      if (localStorage.getItem('identity') !== null) {
        const identity = JSON.parse(localStorage.getItem('identity') as string) as IIdentity;

        const jwtPayload = JwtHelper.getPayload(identity.accessToken) as any;

        if (jwtPayload) {
          ctx.commit('setEmail', jwtPayload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']);
        }
      }
    }
  }
};
